import theme from '../../theme/theme';

const {
  colors: { black_text, subtitle, radio_unchecked, radio_checked },
} = theme;

const styles = {
  scroll__wheel: {
    height: '70vh',
    overflow: 'auto',
    position: 'relative',
    overflowX: 'hidden',
  },

  item__container: {
    height: '5.750em',
    padding: 0,
    paddingRight: '1.5em',
    paddingLeft: '2em',
  },

  icons: {
    fontSize: '1.5em',
    margin: 0,
    padding: 0,
  },

  title: {
    color: black_text,
    fontSize: '1.750em',
    fontWeight: 'normal',
    letterSpacing: '-0.031em',
    width: '15.250em',
  },

  subtitle: {
    color: subtitle,
    fontSize: '1.250em',
    fontWeight: 'normal',
    height: '1.750em',
    letterSpacing: '-0.031em',
    width: '15.250em',
  },

  unchecked__button: {
    fontSize: '1.500em',
    padding: 0,
    margin: 0,
    color: radio_unchecked,
  },

  checked__button: {
    fontSize: '1.500em',
    padding: 0,
    margin: 0,
    color: radio_checked,
  },
};

export default styles;
